module.exports = __webpack_public_path__ + "static/img/14000113.756a0c2d.png";